import * as React from 'react'

import { MenuItemFooter } from 'sdk/menu-items/menu-item-footer/MenuItemFooter'

import { LinksRecord } from 'core/interfaces'

import classes from './style.module.scss'

interface MenuSection {
  label: string
  items: MenuItem[]
}

interface MenuItem {
  label: string
  link: string
  hidden?: boolean
  external?: boolean
}

interface FooterMenuItemsProps {
  showJobs: boolean
  links: LinksRecord
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const buildMenuItems = (showJobs: boolean, links: LinksRecord): MenuSection[] => ([
  {
    label: 'Products',
    items: [
      { label: 'Partner Products', link: '/products' },
      { label: 'GPU Audio SDK', link: '/sdk' },
    ],
  },
  {
    label: 'Community',
    items: [
      { label: 'News & Events', link: 'newsfeed' },
    ],
  },
  {
    label: 'Legal',
    items: [
      { label: 'Cookie Policy', link: 'cookie-policy' },
      { label: 'Privacy Policy', link: 'privacy-policy' },
      { label: 'Terms of Use', link: 'terms-of-use' },
    ],
  },
])

export const FooterMenuItems: React.FC<FooterMenuItemsProps> = ({ showJobs, links }) => {
  const menuItems = buildMenuItems(showJobs, links)

  return (
    <div className={classes.menuContainer}>
      { menuItems.map((menuColumn, colIndex) => (
        <div key={colIndex}>
          <div className={classes.columnTitle}>
            { menuColumn.label }
          </div>
          <ul className={classes.columnList}>
            { menuColumn.items.filter(({ hidden }) => !hidden).map((item, itemIndex) => (
              <li key={itemIndex}>
                <MenuItemFooter link={item.link} external={!!item.external}>
                  { item.label }
                </MenuItemFooter>
              </li>
            )) }
          </ul>
        </div>
      )) }
    </div>
  )
}
